const screens = {
  landing: "landing",
  loading: "loading",
  menu: "menu",
  performance: "performance",
  preorder: "preorder",
  unknown: "unknown",
  product: "product",
  media: "media",
};

const locations = {
  [screens.landing]: "/",
  [screens.menu]: "/menu",
  [screens.performance]: "/performance",
  [screens.preorder]: "/preorder",
  [screens.product]: "/product",
  [screens.media]: "/media",
};

const locationsToScreens = (location) => {
  if (location === locations[screens.landing]) return screens.landing;
  if (location === locations[screens.menu]) return screens.menu;
  if (location === locations[screens.performance]) return screens.performance;
  if (location === locations[screens.preorder]) return screens.preorder;
  if (location === locations[screens.product]) return screens.product;
  if (location === locations[screens.media]) return screens.media;
  return locations[screens.landing];
};

const locationsArray = [
  "/",
  "/menu",
  "/product",
  "/performance",
  "/preorder",
  "/media",
];

const bioPink = "#E31E53";

const colors = {
  pink: "#E31E53",
  purple: "#562F99",
  purple2: "#572F98",
  purple3: "#E448F8",
  purple4: "#803B9B",
};

const menuTitles = {
  product: "Product",
  performance: "Performance",
  media: "Media",
  preorder: "Preorder",
};

const buttonContent = {
  preorder: "PREORDER NOW",
};

const screenHues = {
  [screens.product]: "hue-rotate(90deg)",
  [screens.performance]: "hue-rotate(300deg)",
  [screens.media]: "hue-rotate(200deg)",
  [screens.preorder]: "hue-rotate(20deg)",
};

// console.log({ screenHues })
const screenUse = 96;

const displays = {
  desktop: "desktop",
  tabletHorizontal: "tabletHorizontal",
  tabletVertical: "tabletVertical",
  mobileHorizontal: "mobileHorizontal",
  mobileVertical: "mobileVertical",
};

export {
  bioPink,
  screens,
  locationsArray,
  locations,
  colors,
  menuTitles,
  locationsToScreens,
  buttonContent,
  screenHues,
  displays,
  screenUse,
};
